// The producer page's co-sign strings. They live here rather than in
// copy.ts, which is past the file budget.
export const cosignCopy = {
  heading: "Co-sign",
  action: (username: string) => `Co-sign @${username}`,
  // What a co-sign does for the producer, in cents of every dollar — the
  // backing share, which they keep whether or not they win (EPIC-022).
  keeps: (username: string, cents: string) => `@${username} keeps ${cents} of every $1 you co-sign, win or lose.`,
  // Why the button is not there. The service would refuse these, so the page
  // says so instead of offering a co-sign (invariant 14).
  entrant: "You're in this contest, so you can't co-sign it.",
  unverified: "Verify your email to co-sign.",
  mine: (amount: string) => `You've co-signed ${amount}`,
  failed: "That co-sign didn't go through.",
};

// The between-contests panel: the producer has nothing live to co-sign, so
// the page takes an ask instead of showing a dead end (invariant 16).
export const notifyCopy = {
  heading: "Nothing live right now",
  sub: (username: string) => `@${username} isn't in a contest you can co-sign today. Hear it first when they are.`,
  emailLabel: "Email",
  placeholder: "you@example.com",
  action: "Notify me",
  sending: "Saving…",
  // One email, when they are next up: what the service actually sends.
  done: (username: string) => `Done. You'll get one email when @${username} is next up.`,
  failed: "That didn't go through. Try again.",
};
